module.exports = __webpack_public_path__ + "img/skridsko_rodgaveln.c1437713.jpg";